// Generated by purs version 0.15.0
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Map_Internal from "../Data.Map.Internal/index.js";
import * as Data_Record from "../Data.Record/index.js";
import * as Data_String_Common from "../Data.String.Common/index.js";
import * as Effect_Aff from "../Effect.Aff/index.js";
import * as Restaumatic_Menu_Promotions from "../Restaumatic.Menu.Promotions/index.js";
import * as Restaumatic_Promotions_RPC_Sites_Types from "../Restaumatic.Promotions.RPC.Sites.Types/index.js";
import * as Restaumatic_Promotions_Types_Id from "../Restaumatic.Promotions.Types.Id/index.js";
import * as Type_Proxy from "../Type.Proxy/index.js";
var Promotions = /* #__PURE__ */ (function () {
    function Promotions(value0) {
        this.value0 = value0;
    };
    Promotions.create = function (value0) {
        return new Promotions(value0);
    };
    return Promotions;
})();
var InvalidCoupon = /* #__PURE__ */ (function () {
    function InvalidCoupon() {

    };
    InvalidCoupon.value = new InvalidCoupon();
    return InvalidCoupon;
})();
var NetworkError = /* #__PURE__ */ (function () {
    function NetworkError() {

    };
    NetworkError.value = new NetworkError();
    return NetworkError;
})();
var decodeResponse = function (v) {
    if (v instanceof Data_Either.Right && v.value0 instanceof Data_Either.Right) {
        return new Promotions({
            promotions: Data_Map_Internal.fromFoldable(Restaumatic_Promotions_Types_Id.ordPromotionId)(Data_Foldable.foldableArray)(Data_Functor.map(Data_Functor.functorArray)(Restaumatic_Menu_Promotions.withPromotionId)(Data_Record.getField(Restaumatic_Promotions_RPC_Sites_Types.hasFieldGetActivePromotio1(Data_Record.hasFieldRecord({
                reflectSymbol: function () {
                    return "promotions";
                }
            })()))(Type_Proxy["Proxy"].value)(v.value0.value0))),
            coupons: Data_Record.getField(Restaumatic_Promotions_RPC_Sites_Types.hasFieldGetActivePromotio1(Data_Record.hasFieldRecord({
                reflectSymbol: function () {
                    return "coupons";
                }
            })()))(Type_Proxy["Proxy"].value)(v.value0.value0)
        });
    };
    if (v instanceof Data_Either.Right && v.value0 instanceof Data_Either.Left) {
        return InvalidCoupon.value;
    };
    return NetworkError.value;
};
var getActivePromotionsAndDecode = function (restaurantId) {
    return function (menuConsumer) {
        return function (enteredCouponCodes) {
            return function (promotionsBackend) {
                return Data_Functor.map(Effect_Aff.functorAff)(decodeResponse)(promotionsBackend.getActivePromotions(menuConsumer)({
                    restaurantId: restaurantId,
                    couponCodes: Data_Functor.map(Data_Functor.functorArray)(Data_String_Common.trim)(enteredCouponCodes)
                }));
            };
        };
    };
};
export {
    Promotions,
    InvalidCoupon,
    NetworkError,
    decodeResponse,
    getActivePromotionsAndDecode
};
//# sourceMappingURL=index.js.map
